<template>
  <PageLayout>
    <PageHeader :title="$t(`nameGov`)" />

    <m-card class="ml-2">
      <div class="row-style">
        <img :src="SuccessGovIconSvg" class="mr-2" />

        <h4 class="m-page-title mt-2">
          {{ $t("paymentSuccess") }}
        </h4>
      </div>

      <m-divider class="ma-0 mt-4 mb-8"></m-divider>

      <m-cell>
        <m-cell-item :label="$t('apply.title.IDNumber6')" :value="autoCaseData?.docNo"></m-cell-item>
        <m-cell-item :label="$t('apply.title.liveNumber')" :value="`${autoCaseData.autoNo ?? ``}/${autoCaseData.illegalYear ?? ``
          }`"></m-cell-item>

        <m-cell-item :label="$t('paymentTime')"
          :value="moment(application?.payment?.transactionTime).format(`YYYY-MM-DD HH:mm:ss`)"></m-cell-item>
      </m-cell>

    </m-card>

    <template slot="actions">
      <div class="m-page-footer">
        <m-button block type="primary" ghost size="large" @click="onClose" class="m-footer_button">
          {{ $t("Common.action.complete") }}
        </m-button>

        <m-button block v-if="application?.applicationNo && application?.status == 'FINISHED'" type="primary"
          size="large" @click="downloadReceipts" class="m-footer_button">
          {{ $t("Common.action.downloadReceipts") }}
        </m-button>
      </div>
    </template>
  </PageLayout>
</template>

<script>
import PageLayout from '@/components/PageLayout.vue';
import PageHeader from 'common/components/Layout/web/PageHeader.vue';
import WindowMixins from "govmo-common/src/mixins/WindowMixins";
import { ApplicationAPI } from "govmo-common/src/api";
import { downloadFile } from "govmo-common/src/utils/utils";
import SuccessIconSvg from "govmo-common/src/assets/success.svg";
import SuccessGovIconSvg from "govmo-common/src/assets/successGov.svg";
import moment from "moment";
export default {
  mixins: [WindowMixins],
  components: {
    PageLayout,
    PageHeader,
  },
  computed: {

  },

  async created() {
    this.getSearchData()
  },
  data() {
    return {
      moment,
      SuccessIconSvg,
      SuccessGovIconSvg,
      searchData: null,
      autoCaseData: {},
      autoCaseItems: [],
      application: {},
      result: null,
      payVisible: false,
      transactionNo: null,
    };
  },


  methods: {
    formatMoney(value) {
      return value ? Number(value).toFixed(1) : "0";
    },
    async getSearchData() {
      try {
        this.$showLoading();
        const {
          docNo = "",
          autoNo = "",
          illegalYear = "",
          expire = "",
          signature = "",
        } = this.$route.query;

        const params = { docNo, autoNo, illegalYear, expire, signature };
        const { autoCaseData, autoCaseItems, result, application } =
          await ApplicationAPI.getSignDetails(params);
        this.autoCaseData = autoCaseData;
        this.autoCaseItems = autoCaseItems;
        this.application = application;
        this.result = result;
        this.searchData = { docNo, autoNo, illegalYear };
      } catch (error) {
        this.$error(error);
      } finally {
        this.$hideLoading();
      }
    },
    onClose() {
      this.$router.push("/");
    },
    async downloadReceipts() {
      if (!this.application?.applicationNo) {
        return;
      }

      this.$showLoading();

      const { illegalYear, autoNo, docNo, expire, signature } = this.$route.query;

      try {
        const res = await ApplicationAPI.downloadReceipts(
          {
            illegalYear, autoNo, docNo, expire, signature
          }
        );
        downloadFile(res);
      } catch (error) {
        this.$error(error);
      } finally {
        this.$hideLoading();
      }
    },
  },

};
</script>
<style lang="scss" scoped>
@import "@/meta-variables.scss";

.row-style {
  display: flex;
  align-items: center;
  justify-content: center;

  .img {
    margin-right: 20px;
  }

  .m-page-title {
    font-size: 24px;
    color: var(--m-primary-color);
    font-weight: bold;
  }
}

.m-page-footer {
  display: flex;
  flex-direction: row;
}

.m-footer_button {
  margin-left: 8px;
}

@media screen and (max-width: 576px) {
  ::v-deep(.web-page__content.has-footer) {
    padding-bottom: 8px;
  }

  .m-footer_button {
    margin-bottom: 8px;
    margin-left: 0;
  }

  ::v-deep(.web-page-actions__content) {
    justify-content: center;
    display: contents;
  }

  .m-page-footer {
    display: flex;
    flex-direction: column;
  }
}
</style>